import { IMasterDropdown } from "./MasterDropdowns.types";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { api } from "../../api/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { APIError, ISelectOption } from "../../constants/types";
import { ERROR_MESSAGES } from "../../constants/enums";
import { AppDispatch, RootState } from "../store";

export const fetchMasterDropdownsList = createAsyncThunk<
  {
    data: IMasterDropdown[];
  },
  {
    pageNumber: number;
    rowsInPerPage: number;
    limit: number;
    status: string;
    date: IDataTableV2DateState["dates"];
    searchValue: IDatatableV2AdvancedSearchFilter;
  },
  { rejectValue: APIError }
>(
  "masterDropdowns/fetchMasterDropdownsList",
  async (
    { pageNumber, rowsInPerPage, limit, status, date, searchValue },
    { rejectWithValue },
  ) => {
    try {
      let finalUrl = `/general/get-dropdown?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/general/get-dropdown?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IMasterDropdown[] = res.data.data;
      return {
        data,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);

export const fetchMasterDropdownIfNeeded =
  (code: string) => (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();

    if (state.masterDropdowns.runtimeRefData[code]) return;

    dispatch(fetchMasterDropdownOptions(code));
  };

export const fetchMasterDropdownOptions = createAsyncThunk<
  {
    dropdownCode: string;
    options: ISelectOption[];
  },
  string,
  { rejectValue: APIError }
>(
  "masterDropdowns/fetchMasterDropdownOptions",
  async (dropdownCode, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `/general/get-dropdown?dropdown_code=${dropdownCode}`,
      );
      const data: IMasterDropdown[] = res.data.data;
      if(data.length === 0 || data[0].options === undefined) {
        return {
          dropdownCode,
          options: [],
        };
      }
      const options: ISelectOption[] = (data[0].options || []).map((option) => ({
        label: option.label,
        value: option.value,
      }));
      return {
        dropdownCode,
        options: options,
      };
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);

export const upsertMasterDropdown = createAsyncThunk<
  {},
  { data: IMasterDropdown },
  { rejectValue: APIError }
>(
  "masterDropdowns/upsertMasterDropdown",
  async ({ data }, { rejectWithValue }) => {
    try {
      await api.post("/general/edit-dropdown", {
        ...data,
      });
      return {};
    } catch (err: any) {
      return rejectWithValue({
        message: err.response?.data?.message || ERROR_MESSAGES.SERVER_ERROR,
        status: err.response?.status,
      });
    }
  },
);
